export default __webpack_public_path__ + "static/quote-10-37362acfa60b7a9459cdf06033a7ef93.mp3";